import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import { memoize } from "nodash"
import { selectOpenPlaybackEntities } from "plugins/shared/playback/state/selectors"
import { videoSliceName } from "./slice"

const root = (s: RootState) => s[videoSliceName]

export const selectOpenVideoFlights = createSelector([selectOpenPlaybackEntities], (entities) =>
    entities.filter((e) => e.type === "video").map((e) => e.id)
)
export const selectIsVideoFlightOpen = memoize((flightId: string) =>
    createSelector([selectOpenVideoFlights], (flights) => flights.includes(flightId))
)
export const selectDismissedVideoFlights = createSelector([root], (s) => s.dismissedVideoFlightIds)

export const selectFlightPathEnabledMap = createSelector(
    [root],
    (s) => s.flightPathEnabledByFlightId
)
export const selectIsFlightPathEnabledForFlightId = memoize((flightId: string) =>
    createSelector([root], (s) => s.flightPathEnabledByFlightId[flightId] !== false)
)

export const selectDroneIconEnabledMap = createSelector([root], (s) => s.droneIconEnabledByFlightId)
export const selectIsDroneIconEnabledForFlightId = memoize((flightId: string) =>
    createSelector([root], (s) => s.droneIconEnabledByFlightId[flightId] !== false)
)

export const selectCrosshairEnabledMap = createSelector([root], (s) => s.crosshairEnabledByFlightId)
export const selectIsCrosshairEnabledForFlightId = memoize((flightId: string) =>
    createSelector([root], (s) => s.crosshairEnabledByFlightId[flightId] !== false)
)

export const selectFrameEnabledMap = createSelector([root], (s) => s.frameEnabledByFlightId)
export const selectIsFrameEnabledForFlightId = memoize((flightId: string) =>
    createSelector([root], (s) => s.frameEnabledByFlightId[flightId] !== false)
)

export const selectActiveShareModalFlightId = createSelector(
    [root],
    (s) => s.activeShareModalFlightId
)
